<template>
  <component :is="componentName"></component>
</template>

<script>

import ApprovalStatisticsList from "./list";
import ApprovalStatisticsDetail from "./detail";
export default {
  name: "list",
  components: {
    ApprovalStatisticsDetail,
    ApprovalStatisticsList
  },
  data(){
    return {

    }
  },
 computed:{
   componentName(){
     return this.$route.path.includes('/detail')?'ApprovalStatisticsDetail':'ApprovalStatisticsList'
   }
 }
}
</script>

<style scoped>

</style>